var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClient11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 255.818,
    height: 63.793,
    viewBox: "0 0 255.818 63.793",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo11",
    transform: "translate(-500.85 -4950.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11152",
    "data-name": "Group 11152",
    transform: "translate(500.85 4950.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M383.286-282.571H398V-292.2H383.286Z",
    transform: "translate(-368.56 292.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M367.86-257.1h14.714v-9.573H367.86Z",
    transform: "translate(-367.851 291.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M398.011-257.333v-14.478l-14.478,14.478Z",
    transform: "translate(-368.572 291.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M367.861-292.2v14.535L382.4-292.2Z",
    transform: "translate(-367.851 292.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M383.1-292.211h.179v-.176Z",
    transform: "translate(-368.552 292.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M383.286-256.634v.236l.236-.236Z",
    transform: "translate(-368.56 290.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M367.85-272.047h29.439v-4.916H367.85Z",
    transform: "translate(-367.85 291.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M537.791-226.32a6,6,0,0,1-2.484-.5,4.2,4.2,0,0,1-1.747-1.408,3.519,3.519,0,0,1-.634-2.061c0-.236.021-.547.06-.932s.089-.815.153-1.289.128-.955.2-1.44l.213-1.408,1.575.238c-.124.778-.234,1.5-.33,2.145s-.169,1.2-.22,1.66-.078.8-.078,1.026a2.249,2.249,0,0,0,.408,1.323,2.723,2.723,0,0,0,1.154.907,4.242,4.242,0,0,0,1.729.33,3.99,3.99,0,0,0,1.672-.314,2.4,2.4,0,0,0,1.042-.854,2.317,2.317,0,0,0,.357-1.289v-12.447h1.594v12.447a3.424,3.424,0,0,1-.63,2.068,4.03,4.03,0,0,1-1.678,1.33,5.741,5.741,0,0,1-2.356.467",
    transform: "translate(-375.442 290.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M544.9-230.35v-1.408h6.274l-1.2,1.069v-3.476a5.521,5.521,0,0,0-.279-1.951,1.788,1.788,0,0,0-.907-1.007,4.005,4.005,0,0,0-1.7-.3h-1.374v-1.424h1.374a5.89,5.89,0,0,1,2.409.449,3.12,3.12,0,0,1,1.525,1.477,6.073,6.073,0,0,1,.527,2.755v3.815Z",
    transform: "translate(-375.993 289.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M558.113-230.524v-1.408a.263.263,0,0,1,.27.188,1.51,1.51,0,0,1,.069.508,1.6,1.6,0,0,1-.069.517.262.262,0,0,1-.27.195m-2.033-1.408h2.033v1.408h-2.033Zm-1.578-10.7h1.578v12.106H554.5Z",
    transform: "translate(-376.434 290.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M562.509-230.009v-1.408a.262.262,0,0,1,.279.188,1.751,1.751,0,0,1,.06.508,1.854,1.854,0,0,1-.06.517.261.261,0,0,1-.279.195m-4.238-1.408h4.238v1.408h-4.238Zm0,1.408a.261.261,0,0,1-.279-.195,1.761,1.761,0,0,1-.062-.517,1.664,1.664,0,0,1,.062-.508.262.262,0,0,1,.279-.188Z",
    transform: "translate(-376.592 289.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M567.936-230.35v-1.408a.262.262,0,0,1,.279.188,1.751,1.751,0,0,1,.06.508,1.855,1.855,0,0,1-.06.517.261.261,0,0,1-.279.195m-1.813-1.408h1.813v1.408h-1.813Zm-1.594,2.967h1.594v1.644h-1.594Zm-1.816-1.559v-1.408h2.629l-.813.646v-7.732h1.594v8.495Zm0,0a.261.261,0,0,1-.279-.195,1.854,1.854,0,0,1-.06-.517,1.751,1.751,0,0,1,.06-.508.262.262,0,0,1,.279-.188Z",
    transform: "translate(-376.796 289.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M573.749-230.5V-231.9a.262.262,0,0,1,.279.188,1.678,1.678,0,0,1,.06.508,1.776,1.776,0,0,1-.06.517.261.261,0,0,1-.279.195m-1.917-1.408h1.917v1.408h-1.917Zm-.643-10.1h1.594v1.644h-1.594Zm-2.324,0h1.594v1.644h-1.594Zm-.678,11.513V-231.9h2.883l-.813.646v-7.732h1.575v8.495Zm0,0a.261.261,0,0,1-.279-.195,1.854,1.854,0,0,1-.06-.517,1.751,1.751,0,0,1,.06-.508.262.262,0,0,1,.279-.188Z",
    transform: "translate(-377.048 290.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M576.034-242.63h1.578v12.106h-1.578Zm-2.017,10.7h2.017v1.408h-2.017Zm0,1.408a.261.261,0,0,1-.279-.195,1.855,1.855,0,0,1-.06-.517,1.751,1.751,0,0,1,.06-.508.262.262,0,0,1,.279-.188Z",
    transform: "translate(-377.316 290.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M580.787-230.524h1.578V-242.63h-1.578Z",
    transform: "translate(-377.643 290.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M597.845-230.5V-231.9a.262.262,0,0,1,.279.188,1.753,1.753,0,0,1,.06.508,1.857,1.857,0,0,1-.06.517.261.261,0,0,1-.279.195M593-242.008h1.594v1.644H593Zm-2.324,0h1.594v1.644h-1.594Zm1.765,11.513a5,5,0,0,1-2.324-.449,2.556,2.556,0,0,1-1.211-1.39,6.67,6.67,0,0,1-.366-2.384,6.787,6.787,0,0,1,.366-2.406,2.587,2.587,0,0,1,1.211-1.408,4.936,4.936,0,0,1,2.324-.458h3.595v7.714h-1.578v-6.849l.643.559h-2.661a3.746,3.746,0,0,0-1.408.213,1.258,1.258,0,0,0-.712.829,6.147,6.147,0,0,0-.2,1.807,5.869,5.869,0,0,0,.2,1.772,1.3,1.3,0,0,0,.7.822,3.636,3.636,0,0,0,1.417.22h5.408v1.408Z",
    transform: "translate(-378 290.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M602.516-230.009v-1.408a.262.262,0,0,1,.279.188,1.753,1.753,0,0,1,.06.508,1.857,1.857,0,0,1-.06.517.261.261,0,0,1-.279.195m-4.238-1.408h4.238v1.408h-4.238Zm0,1.408A.261.261,0,0,1,598-230.2a1.763,1.763,0,0,1-.062-.517,1.665,1.665,0,0,1,.062-.508.262.262,0,0,1,.279-.188Z",
    transform: "translate(-378.432 289.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M617.318-230.35v-1.408a.262.262,0,0,1,.279.188,1.676,1.676,0,0,1,.06.508,1.773,1.773,0,0,1-.06.517.261.261,0,0,1-.279.195m-1.813-1.408h1.813v1.408h-1.813Zm-10.446-7.087h1.575v7.087h-1.575Zm-2.34,8.495v-1.408h12.616l-1.424,1.255v-3.881a4.437,4.437,0,0,0-.282-1.706,2.023,2.023,0,0,0-.838-1,2.7,2.7,0,0,0-1.39-.33,3.717,3.717,0,0,0-1.374.254,4.839,4.839,0,0,0-1.186.671,9.125,9.125,0,0,0-1.019.907,12.159,12.159,0,0,0-.856.982q-.381.495-.687.882l-.458-1.321c.327-.4.646-.783.95-1.161a12.014,12.014,0,0,1,.941-1.044,6.581,6.581,0,0,1,1.035-.831,4.828,4.828,0,0,1,1.22-.559,5.239,5.239,0,0,1,1.518-.2,4.217,4.217,0,0,1,1.967.408,3.3,3.3,0,0,1,1.23,1.067,4.372,4.372,0,0,1,.634,1.449,6.585,6.585,0,0,1,.188,1.536v4.034Zm0,0a.262.262,0,0,1-.279-.195,1.854,1.854,0,0,1-.06-.517,1.751,1.751,0,0,1,.06-.508.264.264,0,0,1,.279-.188Z",
    transform: "translate(-378.636 289.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M623.245-230.5v-1.408a.262.262,0,0,1,.279.188,1.672,1.672,0,0,1,.06.508,1.769,1.769,0,0,1-.06.517.261.261,0,0,1-.279.195m-1.813-1.408h1.813v1.408h-1.813Zm-1.594-10.258h1.594v1.644h-1.594ZM618.022-230.5v-1.408h2.629l-.813.646V-239h1.594v8.495Zm0,0a.262.262,0,0,1-.279-.195,1.855,1.855,0,0,1-.06-.517,1.751,1.751,0,0,1,.06-.508.264.264,0,0,1,.279-.188Z",
    transform: "translate(-379.34 290.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M623.5-230.35v-1.408h9.138l-1,.746v-3.51a4.906,4.906,0,0,0-.245-1.745,1.576,1.576,0,0,0-.856-.9,4.163,4.163,0,0,0-1.662-.27,9.564,9.564,0,0,0-1.406.1,4.36,4.36,0,0,0-1.085.272l.966-.95c-.069.261-.135.593-.2,1s-.124.845-.169,1.314-.069.934-.069,1.4a13.569,13.569,0,0,0,.069,1.371c.046.453.1.85.153,1.188s.1.57.135.694l-1.509.424a6.8,6.8,0,0,1-.16-.762c-.064-.362-.119-.8-.172-1.305s-.076-1.044-.076-1.61.025-1.095.076-1.621.115-1,.188-1.431.144-.774.213-1.035a7.2,7.2,0,0,1,1.211-.3,9.992,9.992,0,0,1,1.839-.153,6.091,6.091,0,0,1,2.418.424,2.891,2.891,0,0,1,1.458,1.365,5.614,5.614,0,0,1,.481,2.535v4.172Zm0,0a.261.261,0,0,1-.279-.195,1.854,1.854,0,0,1-.06-.517,1.751,1.751,0,0,1,.06-.508.262.262,0,0,1,.279-.188Z",
    transform: "translate(-379.592 289.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M427.551-285.688v27.518h-7.43v-27.518h-9.237l2.006-6.6h23.9v6.6Z",
    transform: "translate(-369.83 292.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M452.8-285.542h-.245L448.8-272.589h7.819Zm8.064,27.371-2.443-8.115H447.034l-2.443,8.115h-7.526l11.24-34.117h9.189l11.1,34.117Z",
    transform: "translate(-371.034 292.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M482.456-264.427h8.554a3.253,3.253,0,0,0,2.322-.806,2.983,2.983,0,0,0,.854-2.274v-1.662a2.981,2.981,0,0,0-.854-2.271,3.252,3.252,0,0,0-2.322-.806h-8.554Zm0-13.88h7.38a3.111,3.111,0,0,0,2.3-.831,3.11,3.11,0,0,0,.829-2.3V-282.9a3.11,3.11,0,0,0-.829-2.3,3.112,3.112,0,0,0-2.3-.831h-7.38Zm-7.43-13.979H491.6a8.9,8.9,0,0,1,6.622,2.4,8.637,8.637,0,0,1,2.37,6.354,9.461,9.461,0,0,1-.513,3.322,6.4,6.4,0,0,1-1.367,2.249,5.272,5.272,0,0,1-2.006,1.3,8.059,8.059,0,0,1-2.468.465v.293a8.251,8.251,0,0,1,2.567.44,7.341,7.341,0,0,1,2.468,1.392,7.728,7.728,0,0,1,1.882,2.468,8.262,8.262,0,0,1,.758,3.714,10.847,10.847,0,0,1-.659,3.79,9.684,9.684,0,0,1-1.834,3.1,8.52,8.52,0,0,1-2.787,2.077,8.156,8.156,0,0,1-3.519.758H475.026Z",
    transform: "translate(-372.779 292.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M521.2-285.542h-.245l-3.762,12.953h7.819Zm8.064,27.371-2.443-8.115H515.43l-2.443,8.115H505.46l11.24-34.117h9.189l11.1,34.117Z",
    transform: "translate(-374.179 292.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M556.277-264.769a7.17,7.17,0,0,0,5.23-1.857q1.906-1.858,1.905-5.962v-5.28q0-4.1-1.905-5.962a7.17,7.17,0,0,0-5.23-1.857h-5.424v20.919Zm-12.854-27.518h12.854a16.989,16.989,0,0,1,6.159,1.076,12.408,12.408,0,0,1,4.74,3.2,14.672,14.672,0,0,1,3.032,5.328,23.492,23.492,0,0,1,1.074,7.453,23.493,23.493,0,0,1-1.074,7.453,14.673,14.673,0,0,1-3.032,5.328,12.408,12.408,0,0,1-4.74,3.2,16.989,16.989,0,0,1-6.159,1.076H543.422Z",
    transform: "translate(-375.925 292.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M586.109-292.287v20.919a8.591,8.591,0,0,0,1.417,5.4q1.419,1.783,4.742,1.784t4.74-1.784a8.59,8.59,0,0,0,1.417-5.4v-20.919h7.233v20.138a26.5,26.5,0,0,1-.707,6.523,10.534,10.534,0,0,1-2.322,4.545,9.6,9.6,0,0,1-4.156,2.64,19.609,19.609,0,0,1-6.205.856,19.6,19.6,0,0,1-6.207-.856,9.6,9.6,0,0,1-4.156-2.64,10.558,10.558,0,0,1-2.322-4.545,26.5,26.5,0,0,1-.707-6.523v-20.138Z",
    transform: "translate(-377.555 292.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M614.584-258.171v-34.114h7.43v27.516h13l-2.177,6.6Z",
    transform: "translate(-379.198 292.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M420.881-230.316v-11.911h7.469v1.436h-5.809v3.732h4.772v1.4h-4.772v3.906h5.809v1.436Z",
    transform: "translate(-370.289 290.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M429.18-230.159l2.576-4.323-2.576-4.339h1.747l1.919,3.267,1.919-3.267h1.71l-2.576,4.3,2.576,4.357h-1.747l-1.935-3.215-1.9,3.215Z",
    transform: "translate(-370.671 289.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M440.728-229.994a4.422,4.422,0,0,1-2.2-.458,2.515,2.515,0,0,1-1.124-1.479,9.005,9.005,0,0,1-.327-2.679,7.465,7.465,0,0,1,.362-2.567,2.517,2.517,0,0,1,1.177-1.392,4.517,4.517,0,0,1,2.127-.433c.206,0,.458.016.751.043s.593.066.9.112.566.087.785.121l-.053,1.314c-.195-.023-.426-.046-.692-.069s-.517-.044-.76-.06-.444-.027-.6-.027a2.941,2.941,0,0,0-1.445.293,1.568,1.568,0,0,0-.707.934,6.013,6.013,0,0,0-.2,1.729,7.834,7.834,0,0,0,.181,1.875,1.565,1.565,0,0,0,.685,1,2.924,2.924,0,0,0,1.486.3c.16,0,.366-.007.614-.025s.506-.037.779-.06.5-.041.7-.053l.053,1.314c-.231.034-.5.071-.8.112s-.607.076-.907.1-.561.044-.778.044",
    transform: "translate(-371.034 289.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M444.728-230.336V-242.68h1.607v4.115a11.044,11.044,0,0,1,1.175-.4,5.078,5.078,0,0,1,1.383-.206,3.359,3.359,0,0,1,1.841.424,2.192,2.192,0,0,1,.891,1.365,10.152,10.152,0,0,1,.243,2.464v4.582h-1.626v-4.476a9.7,9.7,0,0,0-.119-1.713,1.509,1.509,0,0,0-.476-.925,1.707,1.707,0,0,0-1.081-.284,5.081,5.081,0,0,0-1.236.156,6.712,6.712,0,0,0-.994.309v6.933Z",
    transform: "translate(-371.386 290.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M456.17-231.273a4.848,4.848,0,0,0,.891-.087q.457-.086.872-.2c.277-.073.5-.14.675-.2v-2.594l-2.3.224a1.471,1.471,0,0,0-1.037.408,1.488,1.488,0,0,0-.311,1.01,1.641,1.641,0,0,0,.3,1.056,1.086,1.086,0,0,0,.907.38m-.327,1.28a2.448,2.448,0,0,1-1.868-.676,2.783,2.783,0,0,1-.639-1.987,2.852,2.852,0,0,1,.311-1.427,1.944,1.944,0,0,1,.925-.82,4.289,4.289,0,0,1,1.529-.33l2.507-.243v-.673a1.513,1.513,0,0,0-.364-1.149,1.553,1.553,0,0,0-1.09-.339c-.3,0-.65.014-1.053.037s-.8.05-1.193.085-.744.071-1.056.105l-.069-1.177c.288-.069.632-.131,1.028-.19s.815-.11,1.255-.156a11.669,11.669,0,0,1,1.209-.069,4.163,4.163,0,0,1,1.678.293,1.918,1.918,0,0,1,.966.918,3.583,3.583,0,0,1,.311,1.607v4.252a.65.65,0,0,0,.286.511,1.505,1.505,0,0,0,.63.215l-.05,1.193c-.254,0-.492-.009-.719-.025a2.868,2.868,0,0,1-.614-.112,1.785,1.785,0,0,1-.492-.2,2.588,2.588,0,0,1-.405-.3,7.714,7.714,0,0,1-.813.293,9.157,9.157,0,0,1-1.072.259,6.2,6.2,0,0,1-1.14.105",
    transform: "translate(-371.782 289.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M462.413-230.167v-8.662h1.607v.607a4.386,4.386,0,0,1,.71-.346,7.4,7.4,0,0,1,.916-.3,3.586,3.586,0,0,1,.934-.131,3.353,3.353,0,0,1,1.848.424,2.24,2.24,0,0,1,.891,1.365,9.968,9.968,0,0,1,.252,2.482v4.563h-1.626v-4.476a9.67,9.67,0,0,0-.121-1.713,1.48,1.48,0,0,0-.483-.925,1.746,1.746,0,0,0-1.09-.284,4.142,4.142,0,0,0-.822.085,5.658,5.658,0,0,0-.795.224c-.247.094-.451.181-.614.261v6.828Z",
    transform: "translate(-372.199 289.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M474.623-234.3a2.059,2.059,0,0,0,1.426-.4,1.762,1.762,0,0,0,.424-1.33,1.762,1.762,0,0,0-.424-1.33,2.059,2.059,0,0,0-1.426-.4,1.866,1.866,0,0,0-1.34.4,1.809,1.809,0,0,0-.408,1.33,1.809,1.809,0,0,0,.408,1.33,1.866,1.866,0,0,0,1.34.4m.38,6.862a3.7,3.7,0,0,0,1.781-.327,1.158,1.158,0,0,0,.57-1.09,1.6,1.6,0,0,0-.181-.863.916.916,0,0,0-.632-.364,6.644,6.644,0,0,0-1.193-.085c-.1,0-.245,0-.424-.009l-.552-.018c-.19,0-.362-.014-.511-.025s-.254-.018-.311-.018a2.74,2.74,0,0,0-.675.632,1.307,1.307,0,0,0-.19.735,1.524,1.524,0,0,0,.208.838,1.17,1.17,0,0,0,.71.458,5.544,5.544,0,0,0,1.4.137m.018,1.3a8.826,8.826,0,0,1-2.214-.227,2.114,2.114,0,0,1-1.243-.785,2.638,2.638,0,0,1-.4-1.548,2.213,2.213,0,0,1,.147-.854,2.022,2.022,0,0,1,.451-.657,6.488,6.488,0,0,1,.751-.632,1.057,1.057,0,0,1-.371-.5,1.939,1.939,0,0,1-.131-.726,1.571,1.571,0,0,1,.208-.6,8.09,8.09,0,0,1,.414-.744,2.37,2.37,0,0,1-.666-.474,2.218,2.218,0,0,1-.492-.822,3.882,3.882,0,0,1-.19-1.314,2.685,2.685,0,0,1,.907-2.29,3.942,3.942,0,0,1,2.429-.685,7.579,7.579,0,0,1,.987.071,5.376,5.376,0,0,1,.811.156l2.647-.071v1.264l-1.539-.037a1.754,1.754,0,0,1,.371.607,2.808,2.808,0,0,1,.147.985,3.531,3.531,0,0,1-.38,1.788,2,2,0,0,1-1.149.9,6.31,6.31,0,0,1-1.928.252c-.08,0-.211-.009-.389-.027s-.314-.032-.405-.044a4.862,4.862,0,0,0-.2.511,1.488,1.488,0,0,0-.1.408.685.685,0,0,0,.13.449.9.9,0,0,0,.57.206,13.259,13.259,0,0,0,1.392.053,7.448,7.448,0,0,1,1.987.215,1.694,1.694,0,0,1,1.056.763,3.251,3.251,0,0,1,.311,1.58,2.385,2.385,0,0,1-1.037,2.171,5.324,5.324,0,0,1-2.887.666",
    transform: "translate(-372.602 289.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M481.416-235.06h4.08a3.351,3.351,0,0,0-.476-2.056,1.831,1.831,0,0,0-1.514-.588,1.967,1.967,0,0,0-1.555.6,3.07,3.07,0,0,0-.536,2.04m1.919,5.065a3.851,3.851,0,0,1-2.1-.492,2.77,2.77,0,0,1-1.115-1.477,7.54,7.54,0,0,1-.346-2.473,6.362,6.362,0,0,1,.458-2.629,3.077,3.077,0,0,1,1.287-1.468,3.993,3.993,0,0,1,1.987-.467,3.52,3.52,0,0,1,2.688.959,4.375,4.375,0,0,1,.909,3.084l-.087,1.09h-5.6a3.3,3.3,0,0,0,.467,1.875,1.862,1.862,0,0,0,1.623.632c.334,0,.7-.009,1.1-.025s.792-.039,1.184-.062.726-.046,1-.069l.034,1.209c-.289.046-.634.1-1.037.149s-.82.092-1.253.119-.833.044-1.2.044",
    transform: "translate(-372.998 289.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M492.24-230.316v-11.911h1.66v5.221h5.619v-5.221h1.658v11.911h-1.658v-5.255H493.9v5.255Z",
    transform: "translate(-373.571 290.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M506.241-229.986a2.787,2.787,0,0,1-1.72-.458,2.4,2.4,0,0,1-.822-1.408,11.068,11.068,0,0,1-.224-2.457v-4.511h1.607v4.495a10.9,10.9,0,0,0,.105,1.71,1.385,1.385,0,0,0,.458.918,1.717,1.717,0,0,0,1.062.275,4.021,4.021,0,0,0,1.271-.19,8.007,8.007,0,0,0,.941-.362v-6.846h1.591v8.662H508.92v-.588a7.631,7.631,0,0,1-1.184.536,4.488,4.488,0,0,1-1.5.224",
    transform: "translate(-374.088 289.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M515.685-231.563a2.994,2.994,0,0,0,1.607-.346,1.729,1.729,0,0,0,.726-1.062,7.227,7.227,0,0,0,.19-1.825,7.282,7.282,0,0,0-.163-1.7,1.66,1.66,0,0,0-.563-.95,1.758,1.758,0,0,0-1.088-.3,5.139,5.139,0,0,0-1.193.147,6.341,6.341,0,0,0-.969.3v5.653c.218.023.476.044.769.062s.522.025.682.025m0,1.4c-.266,0-.582-.007-.95-.025s-.742-.046-1.115-.087-.712-.071-1.012-.094V-242.68h1.626v4.064a8.086,8.086,0,0,1,1.09-.364,5.044,5.044,0,0,1,1.33-.19,3.442,3.442,0,0,1,1.884.458,2.51,2.51,0,0,1,1.01,1.417,8.425,8.425,0,0,1,.3,2.5,7.987,7.987,0,0,1-.382,2.741,2.536,2.536,0,0,1-1.278,1.452,5.82,5.82,0,0,1-2.507.44",
    transform: "translate(-374.508 290.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M526.7-243.081V-227",
    transform: "translate(-375.156 290.119)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient11);
export default __webpack_public_path__ + "static/media/client11.e2866369860c100e173c3299c4c90f7b.svg";
export { ForwardRef as ReactComponent };